import { Injectable } from '@angular/core';

import { UserAuthenticationDetails } from '@app/core/interfaces/user-authentication-details';

@Injectable()
export class AuthenticationService {
  private userAuthenticationDetails: UserAuthenticationDetails = {
    token: sessionStorage.getItem('token'),
    mobileBackEndId: sessionStorage.getItem('mcsMobileBackendId'),
    mcsAnonymousKey: sessionStorage.getItem('mcsAnonymousKey'),
    accountNumber: sessionStorage.getItem('accountNumber'),
    customerType: sessionStorage.getItem('CustomerType') || '',
    isNewCustomer: false,
    isAuthenticated: false,
    customerName: '',
    userName: '',
    clientId: sessionStorage.getItem('clientId'),
    opco: sessionStorage.getItem('opco'),
    isAnon: true,
    recaptchaSiteKey: sessionStorage.getItem('recaptchaSiteKey')
  };
  private isResidential: string;

  constructor() {}

  /**
   * function to get customer type
   * @method getCustomerType
   * @param none
   * @returns string
   */
  public getCustomerType(): boolean {

    const customerType = sessionStorage.getItem('CustomerType');
    this.userAuthenticationDetails.isNewCustomer = customerType === 'New' ? true : false;
    return this.userAuthenticationDetails.isNewCustomer;
  }

  /**
   * function to get user authenticate details
   * @method getUserDetails
   * @param none
   * @returns {object} userAuthenticationDetails
   */
  public getUserDetails(): UserAuthenticationDetails {
    return this.userAuthenticationDetails;
  }

  /**
   * function to get user's Bearer Token
   * @method getToken
   * @param none
   * @returns string token
   */
  public getToken(): string {
    return this.userAuthenticationDetails.token;
  }

  /**
   * function to get user's Bearer Token
   * @method getIsAnon
   * @param none
   * @returns string token
   */
  public getIsAnon(): boolean {
    return this.userAuthenticationDetails.isAnon;
  }

  /**
   * function to get user's Bearer Token
   * @method setIsAnon
   * @param none
   * @returns string token
   */
  public setIsAnon(isAnon: boolean): void {
    this.userAuthenticationDetails.isAnon = isAnon;
  }

    /**
   * function to get user's Bearer Token
   * @method setToken
   * @param none
   * @returns none
   */
  public setToken(token: string): void {
    this.userAuthenticationDetails.token = token;
  }

  /**
   * function to get user's Opco
   * @method getOpco
   * @param none
   * @returns string token
   */
  public getOpco(): string {
    return this.userAuthenticationDetails.opco;
  }

  /**
   * function to get the MCS Anonymous Key
   * @method getMcsAnonymousKey
   * @param none
   * @returns string token
   */
  public getMcsAnonymousKey(): string {
    return this.userAuthenticationDetails.mcsAnonymousKey;
  }

  /**
   * function check if the user is authenticated
   * @method isAuthenticated
   * @param none
   * @returns string token
   */
  public isAuthenticated(): boolean {
    return this.userAuthenticationDetails.isAuthenticated;
  }

    /**
   * function check if the user is authenticated
   * @method setIsAuthenticated
   * @param none
   * @returns none
   */
  public setIsAuthenticated(isAuth: boolean): void {
    this.userAuthenticationDetails.isAuthenticated = isAuth;
  }

  /**
   * function to get MCS MBE ID
   * @method getMobileBackendId
   * @param none
   * @returns string token
   */
  public getMobileBackendId(): string {
    return this.userAuthenticationDetails.mobileBackEndId;
  }

  /**
   * function to get recaptcha site key
   * @method getMobileBackendId
   * @param none
   * @returns string token
   */
  public getRecaptchaSiteId(): string {
    return  this.getUserDetails().recaptchaSiteKey;
  }

  /**
   * function to set user authenticate details
   * @method setUserDetails
   * @param {object} userAuthenticationDetails
   * @return none
   */
  public setUserDetails(userAuthenticationDetails: UserAuthenticationDetails): void {
    this.userAuthenticationDetails = userAuthenticationDetails;
  }

  /**
   * function to get service type
   * @method getServiceType
   * @param none
   * @return string
   */
  public getServiceType(): string {
    const serviceTypeFromSession = sessionStorage.getItem('flowType');
    let serviceType = '';
    if (serviceTypeFromSession === 'startService') {
      serviceType = 'start';
    } else if (serviceTypeFromSession === 'stopService') {
      serviceType = 'stop';
    } else if (serviceTypeFromSession === 'moveService') {
      serviceType = 'move';
    } else {
      serviceType = '';
    }
    return serviceType;
  }

  /**
   * function to set residential type
   * @method setResidentialType
   * @param none
   * @return none
   */
  public setResidentialType(residentialType: string): void {
    this.isResidential = residentialType;
  }

  /**
   * function to get residential type
   * @method getResidentialType
   * @param none
   * @return string
   */
  public getResidentialType(): string {
    return this.isResidential;
  }
}
